var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[(_vm.isReady)?[_c('router-view')]:[_c('nuttrema-loader',{attrs:{"showImage":false,"loadingText":"label.application_loading","theme":"grey-logo"}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9f32b6e","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/DcNuttremaWeb.vue
// module id = 3323
// module chunks = 0